import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const UserAuthorizedApi = createApi({
  reducerPath: "UserAuthorizedApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_Authorized_API_URL}/api/user/live/chat/`,
  }),
  tagTypes: ["UserAuthorized"],
  endpoints: (builder) => ({
    // UserAuthorizedData: builder.mutation({
    //   query: (token) => `authorized?token=${token}`,
    // }),

    UserAuthorizedData: builder.mutation({
      query: (data) => ({
        url: "authorized",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (results, error) => [
        { type: "UserAuthorized", results, error, id: "LIST" },
      ],
    }),
    getAuthorizedDataById: builder.query({
      query: (id) => `authorized/${id}`,
      providesTags: (results, error) => [
        { type: "UserAuthorized", results, error, id: "LIST" },
      ],
    }),
  }),
});

export const {
  useUserAuthorizedDataMutation,
  useGetAuthorizedDataByIdQuery
} = UserAuthorizedApi;
